import React, { useContext } from 'react'
import { Col } from 'react-bootstrap'
import objectPath from 'object-path'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { themeDefault } from '../../themes/containerTheme'
import { DesignContext } from 'contexts/DesignContext'
import {
  checkHasShow,
  checkIsShow,
} from 'designer/component/action/condition/Action'
import useAuth from 'hooks/useAuth'
import { getShowUiConfig } from 'designer/component/action/Config'
import { useShowHideTransition } from './ShowHideTransition'
import {
  hasOwn,
  useRequireConfigField,
} from 'components/RequireConfig'

const REQUIRE_CONFIG_FIELD_TYPES = [
  'autocomplete',
  'checkbox',
  'checkboxGroup',
  'checkboxInput',
  'date',
  'dateTime',
  'datetime',
  'input',
  'inputMask',
  'inputSearch',
  'number',
  'radio',
  'richText',
  'select',
  'textarea',
  'time',
]

const ElementWrapper = (props) => {
  let { uischema, children, theme = themeDefault } = props

  const designContext = useContext(DesignContext)
  const { jsonForm, elementAction } = designContext
  const { config } = useAuth()
  const isShowUiConfig = getShowUiConfig({ uischema, config, jsonForm })
  let hasShow = checkHasShow({ designContext, uischema, config: props.config })
  let isShow = checkIsShow({ designContext, uischema, config: props.config })
  let hasIndex = objectPath.has(uischema, 'zIndex')
  let zIndex =
    uischema?.tagname === 'select' && !hasIndex
      ? {}
      : { zIndex: uischema?.zIndex ?? 0 }
  let minWidth = uischema?.minWidth ? {} : { minWidth: uischema?.minWidth }
  let maxWidth = uischema?.maxWidth ? {} : { maxWidth: uischema?.maxWidth }
  let isShowUi = hasShow ? isShow : isShowUiConfig
  const fieldKey = uischema.key || uischema.name || uischema.fieldName || ''
  const fieldAliases = [uischema.name, uischema.fieldName].filter(
    (key) => key && key !== fieldKey,
  )
  const hasEnable = objectPath.has(elementAction, ['isEnable', fieldKey])
  const isEnabled = objectPath.get(elementAction, ['isEnable', fieldKey])
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  const isReadOnly = Boolean(
    isLocked || (hasEnable ? isEnabled === false : uischema.readonly),
  )
  const formData = jsonForm.formData || {}
  const fieldValue = objectPath.has(formData, fieldKey)
    ? objectPath.get(formData, fieldKey)
    : objectPath.get(formData, uischema.name)
  const systemRequired = hasOwn(jsonForm.requireConfigBase || {}, fieldKey)
    ? jsonForm.requireConfigBase[fieldKey]
    : uischema.require
  const requireField = useRequireConfigField({
    fieldAliases,
    fieldKey,
    label: uischema.label || uischema.title || uischema.name,
    type: uischema.tagname,
    value: fieldValue,
    visible: isShowUi,
    readOnly: isReadOnly,
    configurable:
      Boolean(fieldKey) &&
      REQUIRE_CONFIG_FIELD_TYPES.includes(uischema.tagname),
    systemRequired,
  })
  let transitionKey =
    objectPath.get(elementAction, ['showHideTransition', uischema.key]) ||
    objectPath.get(elementAction, ['showHideTransition', uischema.name])
  const showHideTransition = useShowHideTransition(
    isShowUi,
    undefined,
    hasShow,
    transitionKey,
  )

  return (
    <Col
      ref={showHideTransition.ref}
      sm={uischema.layoutWidth}
      data-designer-name={uischema.name}
      style={{
        ...zIndex,
        ...minWidth,
        ...maxWidth,
        padding: uischema.layoutPadding ?? '0 .5rem',
        margin: uischema.layoutMargin ?? '',
        ...showHideTransition.style,
      }}
      hidden={showHideTransition.hidden}
    >
      <MuiThemeProvider theme={theme}>
        {React.cloneElement(children, { requireField })}
      </MuiThemeProvider>
    </Col>
  )
}

export default ElementWrapper
